import React from "react";
import {ReactComponent as HomeIcon} from "../../../../../../../assets/images/phone-homepage/home.svg";
import {ReactComponent as SearchIcon} from "../../../../../../../assets/images/phone-homepage/search.svg";
import {ReactComponent as UserIcon} from "../../../../../../../assets/images/phone-homepage/user.svg";
import {ReactComponent as CartIcon} from "../../../../../../../assets/images/phone-homepage/cart.svg";
import PhoneSimulatorFooter from "../../../../../../components/base/device-simulator/phone-entities/footer";

const UserPhoneHomepageFooter = () => {

    return (
        <>
            <PhoneSimulatorFooter>
                <div className={'phone-bottom-navigation'}>
                    <div className={'home-tab'}>
                        <HomeIcon/>
                        <p>Home</p>
                    </div>
                    <SearchIcon/>
                    <UserIcon/>
                    <CartIcon/>
                </div>
            </PhoneSimulatorFooter>
        </>
    )
}

export default UserPhoneHomepageFooter;
